import React from 'react';

export enum ButtonTheme {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    Decline = 'decline',
}

export const Button: React.FC<{
    id: string;
    theme: ButtonTheme;
    disabled?: boolean;
    handleClick?: React.MouseEventHandler;
    hint?: string;
    width?: string;
    children: any;
}> = ({ id, theme, handleClick, hint, disabled = false, width = 'auto', children }) => {
    const setStyle = {
        cursor: `${!handleClick || disabled ? 'arrow' : 'pointer'}`,
        width: width,
    };

    return (
        <>
            <div
                id={id}
                className={`standardButton ${theme} ${disabled ? 'disabled' : 'active'}`}
                style={setStyle}
                onClick={handleClick}
                title={hint}
            >
                {children}
            </div>
        </>
    );
};
